import React from 'react';
import {Redirect, Switch} from 'react-router-dom';
import Header from "components/HeaderForms/"
import Sidenav from 'components/SidenavForms'
import Footer from 'components/Footer'

import Framework from '@beardeddevops/react.framework';
import ErrorBoundaryRoute from "../../../containers/ErrorBoundaryRoute";

import Forms from "../routes/forms/index"


export default class FormsApp extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			name: "",
			account: "",
		};
	}

	render() {
		const {match} = this.props;
		return (
			<div className="main-app-container">
				<Sidenav history={this.props.history}/>

				<section id="page-container" className="app-page-container" >
					<Header
						name={this.state.name}
					/>
					<div className="app-content-wrapper" >
						<div className="app-content">
							<div className="full-height">
								<Switch>
									<ErrorBoundaryRoute path={`${match.url}`}>
										<Forms/>
									</ErrorBoundaryRoute>

									<Redirect to={`${match.url}`}/>
								</Switch>
							</div>
						</div>
						<Footer/>
					</div>
				</section>

			</div>
		);
	}
}
FormsApp = Framework.Components.withRootState(FormsApp);
